export const BUSINESS_INFO = {
    name: 'ARA Mobile Valeting',
    phone: '+44 795 655 3571',
    phoneDisplay: '+44 (795) 655 3571',
    email: 'info@aramobilevaleting.co.uk',
    website: 'aramobilevaleting.co.uk',
    whatsappLink: 'https://wa.me/447956553571',
    address: 'Mobile Service - Covering Greater Sheffield & Surrounding Areas',
  };
  
  export const OPENING_HOURS = {
    weekday: {
      days: 'Monday - Friday',
      hours: '10:00 - 20:00',
    },
    weekend: {
      days: 'Saturday - Sunday',
      hours: '10:00 - 18:00',
    },
  };
  
  export const NAV_LINKS = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/reviews', label: 'Reviews' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' },
  ];